import {Injectable, Injector} from '@angular/core';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';

import * as fromAuthModule from '@orga-app/auth/reducer';
import {LoadingController} from '@ionic/angular';
import {PageState} from './veranstaltungen-info-kategorien.reducer';

@Injectable()
export class VeranstaltungenInfoKategorienPageUiEffects {
    loading: any; // Loading;

    constructor(private actions$: Actions,
                private store$: Store<PageState>,
                private storeAuth: Store<fromAuthModule.ModuleState>,
                public loadingCtrl: LoadingController,
                private injector: Injector) {
    }
}
